import { render, staticRenderFns } from "./messagelist.vue?vue&type=template&id=6e44ef96&scoped=true"
import script from "./messagelist.vue?vue&type=script&lang=js"
export * from "./messagelist.vue?vue&type=script&lang=js"
import style0 from "./messagelist.vue?vue&type=style&index=0&id=6e44ef96&prod&lang=css"
import style1 from "./messagelist.vue?vue&type=style&index=1&id=6e44ef96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e44ef96",
  null
  
)

export default component.exports